import { useState } from "react";
import { Navigate } from "react-router-dom";
import ErrorBoundary from "@/components/shared/ErrorBoundary";
import { BudgetTabContent } from "@/components/project/BudgetTabContent";
import { useProjectDetailContext } from "@/contexts/ProjectDetailContext";

export default function BudgetPage() {
  const {
    project,
    budgetLines,
    timeEntries,
    voucherAllocations,
    allUsers,
    internalReadOnly,
    offerMetadata,
    permissions,
  } = useProjectDetailContext();
  const [editingBudgetLineId, setEditingBudgetLineId] = useState<string | null>(null);

  // VIB-1168: Timetildeling gates nå på «Budsjett»-rettigheten (Se/Endre), ikke
  // den gulv-gitte view_economics. view_budget (Se) styrer om fanen kan åpnes;
  // edit_budget (Endre) gater tildeling/redigering/splitt/import. Gir reell
  // lese-kontroll på hvem som ser timetildelinger. Admin/superadmin overstyrer.
  if (!permissions.view_budget) {
    return <Navigate to={`/prosjekter/${project.id}`} replace />;
  }

  return (
    <ErrorBoundary>
      <BudgetTabContent
        project={project}
        budgetLines={budgetLines}
        timeEntries={timeEntries}
        voucherAllocations={voucherAllocations}
        allUsers={allUsers}
        editingBudgetLineId={editingBudgetLineId}
        setEditingBudgetLineId={setEditingBudgetLineId}
        internalReadOnly={internalReadOnly}
        canAssignHours={permissions.edit_budget}
        offerMetadata={offerMetadata}
      />
    </ErrorBoundary>
  );
}
